import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getPost } from "@/api";
import { useSeo, articleSchema } from "@/seo";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { CalendlyCta } from "@/components/SiteChrome";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useSeo({
    title: post ? `${post.title}, TruVerse Middle East` : "Insights, TruVerse Middle East",
    description: post?.excerpt,
    schema: post ? articleSchema(post) : null,
  });

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    getPost(slug).then(setPost).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="container-site py-32" data-testid="post-not-found">
        <p className="text-muted-foreground">This article could not be found.</p>
        <Link to="/insights" className="mt-4 inline-block text-sm font-semibold text-accent">Back to insights</Link>
      </div>
    );
  if (!post) return <div className="container-site py-32 text-muted-foreground" data-testid="post-loading">Loading…</div>;

  return (
    <div data-testid="blog-post-page">
      <section className="bg-ink py-20 lg:py-28">
        <div className="container-site max-w-3xl">
          <Reveal>
            <Link to="/insights" data-testid="post-back-link" className="inline-flex items-center text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted hover:text-accent">
              <ArrowLeft size={14} className="mr-2" /> All insights
            </Link>
            <Eyebrow>{post.category}</Eyebrow>
            <h1 className="mt-4 text-3xl leading-tight tracking-tight md:text-5xl">{post.title}</h1>
            <p className="mt-6 text-xs uppercase tracking-[0.2em] text-ink-muted" data-testid="post-date">
              {new Date(post.created_at).toLocaleDateString("en-AE", { day: "numeric", month: "long", year: "numeric" })} · {post.author}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20">
        <div className="container-site max-w-3xl">
          <Reveal>
            <div className="space-y-6" data-testid="post-body">
              {post.body.split("\n\n").map((para, i) => (
                <p key={i} className="text-base leading-relaxed text-foreground/90 md:text-lg">
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-16 border border-border bg-card p-8 md:p-10" data-testid="post-cta-box">
              <h2 className="text-2xl text-foreground">Discuss this with a senior advisor.</h2>
              <p className="mt-3 text-sm text-muted-foreground">A thirty-minute conversation. No obligation.</p>
              <div className="mt-6">
                <CalendlyCta testId="post-book-btn" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
